"use strict";
var controller = function($scope, $rootScope, $http) {
  $scope.getList = function() {
    $scope.loading = true;
    var params = {params: {}};
    $http.get('api/thesaurus.json', params).success(function(data, status, headers, config) {
      $scope.thesauruses = data;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  var init = function() {
    $scope.getList();
  }();
};
module.exports = controller;
